export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10683.00d57098.jpg";